"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { MEASUREMENT_CONSENT_EVENT } from "@/lib/analytics/openaiPixel";

const STORAGE_KEY = "cookie-consent";

export default function CookieConsentBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(STORAGE_KEY)) {
            setVisible(true);
        }
    }, []);

    if (!visible) return null;

    const accept = () => {
        localStorage.setItem(STORAGE_KEY, "true");
        window.dispatchEvent(new Event(MEASUREMENT_CONSENT_EVENT));
        setVisible(false);
    };

    return (
        <div
            role="dialog"
            aria-label="Cookie consent"
            className="t-fixed t-bottom-0 t-inset-x-0 t-z-50 t-bg-gray-900 t-text-white t-px-6 t-py-4 print-hide">
            <div className="t-mx-auto t-flex t-max-w-7xl t-flex-col t-items-center t-gap-4 sm:t-flex-row sm:t-justify-between">
                <p className="t-text-sm t-leading-relaxed">
                    By accessing our site, you acknowledge that we and our partners use cookies and similar
                    technologies as described in our{" "}
                    <Link
                        href="/privacy"
                        className="t-underline t-font-medium">
                        Privacy Policy
                    </Link>
                    , and you agree to our{" "}
                    <Link
                        href="/terms"
                        className="t-underline t-font-medium">
                        Terms of Use
                    </Link>
                    .
                </p>
                <button
                    onClick={accept}
                    className="t-shrink-0 t-rounded t-bg-white t-px-6 t-py-2 t-text-sm t-font-semibold t-text-gray-900 hover:t-bg-gray-100 t-transition-colors">
                    Got it
                </button>
            </div>
        </div>
    );
}
